import { Handler, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/CatalogPages/Handlers/LoadCatalogPageByPath";
import {
    CatalogPage,
    CatalogPageResult,
    getCatalogPageByPath,
    GetCatalogPageByPathApiParameter,
} from "@tCentro/Services/CategoryServiceExtension";

type Parameter = {
    path: string;
} & HasOnSuccess<CatalogPage>;
type Props = {
    apiParameter: GetCatalogPageByPathApiParameter;
    apiResult: CatalogPageResult;
};

type HandlerType = Handler<Parameter, Props>;

export const RequestDataFromApiExtended: HandlerType = async props => {
    try {
        props.apiResult = await getCatalogPageByPath(props.apiParameter);
    } catch (error) {
        if ("status" in error && error.status === 404) {
            props.dispatch({
                type: "Data/CatalogPages/FailedToLoadCatalogPage",
                path: props.parameter.path,
                status: 404,
            });
            return false;
        }
        throw error;
    }
};

replaceInChain(chain, RequestDataFromApi, RequestDataFromApiExtended);